import { lazy, Suspense } from 'react';
import { Route, Routes } from "react-router";
import Navbar from './components/navbar.jsx'
// import Home from './pages/home';
// import Login from './components/login';
// import Register from './components/register';
// import CheckoutForm from './shipping/checkoutForm';
// import Admin from './pages/admin/admin';
// import UsersList from './pages/admin/users/UsersList';
// import UserDetail from './pages/admin/users/UserDetail';
// import AdminLayout from './pages/admin/adminLayout';

// import Product from './pages/products/product';

  const HomeLayout = lazy(() => import('./pages/homeLayout'))
  const Home = lazy(() => import('./pages/home'))
  const Login = lazy(() => import('./components/login'))
  const Register = lazy(() => import('./components/register'))
  const CheckoutForm = lazy(() => import('./shipping/checkoutForm'))
  const Admin = lazy(() => import('./pages/admin/admin'))
  const UsersList = lazy(() => import('./pages/admin/users/UsersList'))
  const UserDetail = lazy(() => import('./pages/admin/users/UserDetail'))
  const AdminLayout = lazy(() => import('./pages/admin/adminLayout'))
  const Product = lazy(() => import('./pages/products/product'))
  const ProductsList = lazy(() => import('./pages/admin/products/ProductsList'))
  const ProductDetail = lazy(() => import('./pages/admin/products/ProductDetail'))

// import './App.css';

function App() {
  return (
    <div className="">
      <header className="flex flex-col items-center bg-slate-900 min-h-screen ">
        <Navbar />
        <Suspense fallback={<p><i>Loading...</i></p>}>
          <Routes>
            <Route element={<HomeLayout />} >
              <Route index element={<Product />} />
              <Route path="/products" element={<Product />} />
              <Route
                path="/c/:categoryId?/p?/:productId?"
                element={<Product />}
              />
            </Route>

            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />

            <Route path="admin" element={<AdminLayout />}>
              <Route index element={<Admin />} />
              <Route path="users" element={<UsersList />} />
              <Route path="users/:userid" element={<UserDetail />} />

              <Route path="products" element={<ProductsList />} />
              <Route
                path="/admin/product/:productid"
                element={<ProductDetail />}
              />
              <Route path="/admin/*" element={<Admin />} />

            </Route>

            {/* <Route element={<PrivateRoute />} >
              <Route  path="/pos" element={<PosLayout />} >
                <Route index element={<Dashboard />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="checkout" element={<CheckOut />} />
                <Route path="invoices" element={<Invoices />} />
                <Route path="/pos/products" element={<ProductsLayout />} >
                  <Route index element={<Products />} />
                  <Route path=":id" element={<Products />} />
                </Route>
              </Route>
              <Route path="users" element={<PosLayout />} >
                <Route index element={<UserList />} />
                <Route path=":userid" element={<UserDetail />} />
              </Route>

              <Route path="products" element={<PosLayout />} >
                <Route index element={<ProductsList />} />
                <Route path="stocks" element={<Stock />} />
                <Route path="stocktrans" element={<StockTrans />} />
                <Route path=":productid" element={<ProductDetail />} />
              </Route>
    
            </Route> */}

            <Route path="/checkout" element={<CheckoutForm />} />

            <Route path="*" element={<Home />} />

          </Routes>  
        </Suspense>
        {/* <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a> */}
      </header>
    </div>
  );
}

export default App;
